const scrollToForm = () => {
  document.getElementById("assessment-form")?.scrollIntoView({ behavior: "smooth" });
};

const Header = () => (
  <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-stone-200">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
      <a href="/" data-testid="header-logo" className="font-['Manrope'] font-bold text-lg tracking-tight text-stone-900">
        CafeTransport<span className="text-orange-600">.pro</span>
      </a>
      <nav className="flex items-center gap-6">
        <a
          href="mailto:info@cafetransport.pro"
          data-testid="header-contact-link"
          className="hidden sm:block text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors duration-200"
        >
          Contact
        </a>
        <button
          onClick={scrollToForm}
          data-testid="header-quote-button"
          className="rounded-full bg-orange-600 px-5 py-2 text-sm font-semibold text-white hover:bg-orange-700 hover:-translate-y-px transition-[background-color,transform] duration-200"
        >
          Request a Quote
        </button>
      </nav>
    </div>
  </header>
);

export default Header;
